<template>
  <div class="btn-group">
    <button v-if="canEdit" class="btn btn-secondary btn-sm" @click="edit">
      <i class="fas fa-edit"></i>
    </button>
    <button v-if="canDelete" class="btn btn-danger btn-sm" @click="confirmDeleting">
      <i class="fas fa-trash-alt"></i>
    </button>
    <button v-if="canRestore" class="btn btn-success btn-sm" @click="confirmRestore">
      <i class="fas fa-reply"></i>
    </button>
  </div>
</template>

<script>

export default {
  props: [
    'row'
  ],

  computed: {
    /**
     * @return {boolean}
     */
    canEdit() {
      return this.row.canEdit && !this.isTrashed;
    },

    /**
     * @return {boolean}
     */
    canDelete() {
      return this.row.canDelete && !this.isTrashed;
    },

    /**
     * @return {boolean}
     */
    canRestore() {
      return this.row.canRestore && this.isTrashed;
    },

    /**
     * @return {string}
     */
    editUrl() {
      return this.row.editUrl;
    },

    /**
     * @return {string}
     */
    deleteUrl() {
      return this.row.deleteUrl;
    },

    /**
     * @return {String}
     */
    restoreUrl() {
      return this.row.restoreUrl;
    },

    /**
     * @return {boolean}
     */
    isTrashed() {
      return Boolean(_.get(this.row, 'model.is_trashed'));
    },
  },

  methods: {
    /**
     * @event edit
     */
    edit() {
      this.$emit('edit', {row: this.row, url: this.editUrl});
    },

    /**
     * @event delete
     */
    confirmDeleting() {
      this.$confirm('Are you sure you want to delete this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('delete', {row: this.row, url: this.deleteUrl}))
          .catch(() => {
          });
    },

    /**
     * @event restore
     */
    confirmRestore() {
      this.$confirm('Are you sure you want to restore this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('restore', {row: this.row, url: this.restoreUrl}))
          .catch(() => {
          });
    },
  },
}
</script>
